import { render } from "./LinkRedirects.vue?vue&type=template&id=2d59365a&scoped=true"
import script from "./LinkRedirects.vue?vue&type=script&lang=js"
export * from "./LinkRedirects.vue?vue&type=script&lang=js"

import "./LinkRedirects.vue?vue&type=style&index=0&id=2d59365a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d59365a"]])

export default __exports__